import api from '@/services/api/config';

const path = 'v1/infra/wep';

export default {
  getArtikel: (wep) => api.get(`${path}/${wep}/artikel`),
};
